// The seam between the Splash and whatever knows about the session.
//
// The Splash only needs one answer: is someone signed in on this phone?
// Keeping that behind a function type lets its timing rules be tested
// without Firebase, and lets the Firebase side change without touching
// the screen.

/** Resolves true when a signed-in session exists on this device. */
export type SessionCheck = () => Promise<boolean>;

/**
 * The Firebase session check. firebase.ts is loaded on demand: it throws
 * while the config is blank (HANDOFF.md, step F5), and that must cost the
 * athlete the sign-in screens only, not the whole app.
 */
export const firebaseSessionCheck: SessionCheck = async () => {
  const { auth } = await import("../lib/firebase");
  // Resolves once Firebase has read the persisted session, offline too.
  await auth.authStateReady();
  return auth.currentUser !== null;
};
